import { render, staticRenderFns } from "./RatioIn.vue?vue&type=template&id=4aa245b2&scoped=true"
import script from "./RatioIn.vue?vue&type=script&lang=js"
export * from "./RatioIn.vue?vue&type=script&lang=js"
import style0 from "./RatioIn.vue?vue&type=style&index=0&id=4aa245b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa245b2",
  null
  
)

export default component.exports